<template>
    <div class="module">
        <header class="module__header--with-disclaimer">
            <a
                class="back-btn"
                data-test-id="create-encryption-key-page-back-arrow"
                @click="goBack('admin-encryption-keys')"
            >
                <span class="icon-chevron-left" />
            </a>
            <h1 class="has-back-btn">Create Encryption Key</h1>
        </header>

        <section class="module__body">
            <create-encryption-key @encryption-key-created="encryptionKeyCreated" />

            <div class="form-help">Encryption Keys cannot be edited after they’re created.</div>
        </section>
    </div>
</template>

<script>
import CreateEncryptionKey from '@/components/CreateEncryptionKey.vue'
import canToast from '@/mixins/canToast'
import hasBackButton from '@/mixins/hasBackButton'
import needsOrganizationSlug from '@/mixins/needsOrganizationSlug'

export default {
    components: {
        CreateEncryptionKey,
    },

    mixins: [canToast, hasBackButton, needsOrganizationSlug],

    data() {
        return {
            name: null,
            errorResponse: null,
            submitted: false,
        }
    },

    methods: {
        encryptionKeyCreated() {
            this.$router.push(`/${this.organizationSlug}/encryption-keys`)
        },
    },
}
</script>
<style scoped lang="scss">
.module__body {
    display: flex;

    form {
        max-width: 360px;
    }
}
</style>
